import { render } from "./RentalContractRegistration.vue?vue&type=template&id=44578187&ts=true"
import script from "./RentalContractRegistration.vue?vue&type=script&lang=ts"
export * from "./RentalContractRegistration.vue?vue&type=script&lang=ts"

import exportComponent from "/home/asan/haisha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__